import React, { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './style.web.css';
import { StyleSheet, View } from 'react-native';
import Text from '../text';
import moment from 'moment';
import { useIsFocused } from '@react-navigation/native';
import PropTypes from 'prop-types';

const DatePickerComponent = (props) => {
  const focus = useIsFocused();
  const [state, setState] = useState({
    value: null,
    placeholder: props.placeholder || "dd/mm/yyyy",
  });

  useEffect(() => {
    if (props?.value) {
      const parsed = moment(props.value, ['MM/DD/YYYY', 'YYYY-MM-DD', 'DD/MM/YYYY'], true);
      if (parsed.isValid()) {
        setState(prev => ({
          ...prev,
          value: parsed.format('MM/DD/YYYY')
        }));
      } else {
        const d = new Date(props.value);
        if (!isNaN(d.getTime())) {
          setState(prev => ({
            ...prev,
            value: moment(d).format('MM/DD/YYYY')
          }));
        } else {
          setState(prev => ({ ...prev, value: null }));
        }
      }
    } else {
      setState(prev => ({ ...prev, value: null }));
    }
  }, [props?.value, props?.placeholder]);

  const getSafeSelectedDate = () => {
    if (!state.value) return null;
    const d = new Date(state.value);
    return isNaN(d.getTime()) ? null : d;
  };

  const onChange = (date) => {
    if (date === null) {
      // When cleared, send null to parent and reset local state
      props?.onUpdateInput(null);
      setState(prev => ({ ...prev, value: null }));
    } else {
      const formattedDate = moment(date).format('MM/DD/YYYY');
      props?.onUpdateInput(formattedDate);
    }
  };

  return (
    <If condition={focus}>
      <View
        style={{
          width: props?.showMonths ? 0 : '100%',
          alignItems: 'flex-start',
          marginBottom: 10,
        }}
      >
        {props.title && (
          <Text fontWeight={'600'} lineHeight={22} marginBottom={10} fontSize={16}>
            {props.title}
          </Text>
        )}
        <View
          style={
            props?.showMonths
              ? {
                  justifyContent: 'center',
                  padding: 5,
                  width: 20,
                  height: 20,
                  backgroundColor: 'transparent',
                  position: 'absolute',
                  top: '-8px',
                  right: 0,
                  left: 0,
                  display: 'flex',

                }
              : {
                  width: '100%',
                  height: 44,
                  borderWidth: 1.5,
                  justifyContent: 'center',
                  paddingHorizontal: 12,
                  borderColor: '#E5E7EB',
                  borderRadius: 8,
                  display: 'flex',
                  backgroundColor: props?.backgroundColor ? 'rgba(159,120,255,0.16)' : '#FFFFFF',
                }
          }
        >
          <DatePicker
            onChange={onChange}
            selected={getSafeSelectedDate()}
            placeholderText={props?.showMonths?"": state.placeholder}
            portalId="root-portal"
            dateFormat={props?.showMonths ? 'MMM yyyy' : 'dd/MM/yyyy'}
            showMonthYearPicker={props?.showMonths ? true : false}
            yearDropdownItemNumber={100}
            scrollableYearDropdown={true}
            showYearDropdown
            showMonthDropdown
            disabled={props?.isDisable}
            minDate={props?.minDate ? moment(props?.minDate).toDate() : undefined}
            maxDate={props?.maxDate ? moment(props?.maxDate).toDate() : undefined}
            isClearable={true}
            shouldCloseOnSelect={true}
          />
        </View>
      </View>
    </If>
  );
};

DatePickerComponent.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onUpdateInput: PropTypes.func.isRequired,
  isDisable: PropTypes.bool,
  showMonths: PropTypes.bool,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  title: PropTypes.string,
  backgroundColor: PropTypes.string,
};

DatePickerComponent.defaultProps = {
  placeholder: "dd/mm/yyyy",
  isDisable: false,
  showMonths: false,
};

export default DatePickerComponent;
